import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { TrendingUp, Users, MousePointerClick, QrCode } from "lucide-react";

const KPICards = ({
  totalTransitions,
  totalRegistrations,
  totalClicks,
  activePages,
  conversionRate,
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Всего переходов</CardTitle>
          <QrCode className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{totalTransitions}</div>
          <p className="text-xs text-muted-foreground">QR-сканеры</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Регистрации</CardTitle>
          <Users className="h-4 w-4 text-emerald-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-emerald-600">{totalRegistrations}</div>
          <p className="text-xs text-muted-foreground">конверсия {conversionRate}%</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Клики по кнопкам</CardTitle>
          <MousePointerClick className="h-4 w-4 text-blue-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-blue-600">{totalClicks}</div>
          <p className="text-xs text-muted-foreground">Max / Telegram / SMS</p>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Активные карты</CardTitle>
          <TrendingUp className="h-4 w-4 text-purple-600" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-purple-600">{activePages}</div>
          <p className="text-xs text-muted-foreground">кампаний</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default KPICards;